"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeClientId = exports.setClientId = exports.getClientId = exports.removeBenchmarkResult = exports.setBenchmarkResult = exports.getBenchmarkResult = void 0;
const prefix = "";
class VolatileStorage {
    constructor() {
        this.data = new Map();
    }
    getItem(key) {
        const r = this.data.get(key);
        return r === undefined ? null : r;
    }
    setItem(key, value) {
        this.data.set(key, value);
    }
    removeItem(key) {
        this.data.delete(key);
    }
    clear() {
        this.data.clear();
    }
}
const storage = isLocalStorageAvailable() ? localStorage : new VolatileStorage();
var Keys;
(function (Keys) {
    Keys["BenchmarkResult"] = "benchmarkResult";
    Keys["ClientID"] = "clientId";
})(Keys || (Keys = {}));
function fullKey(k) {
    return prefix + k;
}
function getBenchmarkResult(logger) {
    const dataStr = storage.getItem(fullKey(Keys.BenchmarkResult));
    if (dataStr == null) {
        return null;
    }
    try {
        const data = JSON.parse(dataStr);
        if (typeof data !== "object") {
            return null;
        }
        ;
        if (typeof data.timestamp !== "number") {
            return null;
        }
        ;
        if (typeof data.result1 !== "number") {
            return null;
        }
        ;
        if (typeof data.result2 !== "number" && data.result2 !== null) {
            return null;
        }
        ;
        return data;
    }
    catch (err) {
        logger.error(`Error parsing benchmark result from localStorage`, err);
        return null;
    }
}
exports.getBenchmarkResult = getBenchmarkResult;
function setBenchmarkResult(data) {
    storage.setItem(fullKey(Keys.BenchmarkResult), JSON.stringify(data));
}
exports.setBenchmarkResult = setBenchmarkResult;
function removeBenchmarkResult() {
    storage.removeItem(fullKey(Keys.BenchmarkResult));
}
exports.removeBenchmarkResult = removeBenchmarkResult;
function getClientId() {
    return storage.getItem(fullKey(Keys.ClientID));
}
exports.getClientId = getClientId;
function setClientId(data) {
    storage.setItem(fullKey(Keys.ClientID), data);
}
exports.setClientId = setClientId;
function removeClientId() {
    storage.removeItem(fullKey(Keys.ClientID));
}
exports.removeClientId = removeClientId;
function isLocalStorageAvailable() {
    try {
        const storage = window['localStorage'];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
//# sourceMappingURL=localStorage.js.map